








































import VueOptions from '@utils/VueOptions'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'
import FormFieldTimePicker from '@ui/FormBuilder/FormFields/FormFieldTimePicker'

settings =
  name: 'FormFieldSearchAddress'

  vue:
    props: ['value', 'errors', 'placeholder', 'disabled']

    components: {
      FormFieldRadioButton,
      FormFieldTimePicker,
    }

    data: ->
      value_: @value

    computed:
      weekdays: -> ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

      optionsForEnable: ->
        [
          { label: 'Yes', value: true }
          { label: 'No', value: false }
        ]

    methods:
      hiInputChange: (...args) ->
        @value_ = @value
        @$emit 'input', @value
        @$emit 'change', @value

    watch:
      value: (v) ->
        @value_ = v

export default VueOptions.vue settings
